/* global window */

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ConserveParameters from '@3plearning/routing-conserve-parameters';
import { I18nProvider } from '@lingui/react';
import {
  ThemeProvider,
  Container
} from '@3plearning/react-components';
import 'regenerator-runtime/runtime';
import css from './entry-app.scss';
import { upfTheme } from '../../themes/index';
import '../../styles/core.scss';
import BasicApp from './basic-app';
import UpfAssign from '../upf-assign/upf-assign';
import { header, button } from '../../themes/upf-theme/overrides';
import Header from './header';
import Storage from '../../helpers/local-storage';
import { AnalyticsAppProvider, AnalyticsListener } from '../../analytics';

ConserveParameters(['username', 'password', 'userToken']);
Storage.namespace = 'assessment-assign';

export const theme = Object.assign({}, upfTheme, {
  overrides: {
    header,
    button
  }
});

export default class EntryApp extends BasicApp {
  render(store, i18n) {
    // TODO: 4. DEFINE THE TOP-LEVEL ROUTES FOR YOUR APPLICATION'S COMPONENTS HERE

    // When executing on demo, QA, or production, the host app will inject a property
    // called pppAppConfig into the global window variable.  This will provide the
    // base name of the app.  Most of the time that will be an empty string, but in
    // case it is not, we will extract it and pass it to the router, below.

    // NOTE: We have used a "render" attribute, rather than "component" to specify what
    //       should be rendered.  This allows us to pass options to the component. You
    //       can obviously simplify things if your components don't need any.

    return (
      <I18nProvider i18n={i18n} >
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <Router history={history}>
              {i18n && <AnalyticsAppProvider>
                <AnalyticsListener />
                <div className={css.app}>
                  <Header i18n={i18n} />
                  <Container className={css['container-wrapper']}>
                    <Switch>
                      <Route path="/" render={() => <UpfAssign i18n={i18n} />} />
                    </Switch>
                  </Container>
                </div>
              </AnalyticsAppProvider>}
            </Router>
          </ThemeProvider>
        </Provider>
      </I18nProvider>
    );
  }
}

window.EntryApp = EntryApp;
